/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Gallery_Desc_OutlookInputs */



/**
* | output |
* | --- |
* | "Emails and folders from your mailbox." |
*
* @param {Spaces_Gallery_Desc_OutlookInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_gallery_desc_outlook = /** @type {((inputs?: Spaces_Gallery_Desc_OutlookInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Gallery_Desc_OutlookInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("E-Mails und Ordner aus deinem Postfach.")
	return /** @type {LocalizedString} */ ("Emails and folders from your mailbox.")
});